import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { CreateChatModel } from '../../models/create-chat-model';
import { HeaderHelperService } from '../header-helper.service';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  chatList(patientRecordCaseId: string): Observable<any> {
    let url = `${environment.apiLocations.chat}/Chat/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  chat(createChatModel: CreateChatModel): Observable<any> {
    const url = `${environment.apiLocations.chat}/Chat/${createChatModel.patientRecordCaseId}`;
    const formData: FormData = new FormData();
    formData.append('PatientRecordCaseId', createChatModel.patientRecordCaseId);
    formData.append('CreatedUserName', createChatModel.createdUserName);
    formData.append('PatientName', createChatModel.patientName);
    formData.append('PatientSurname', createChatModel.patientSurname);
    formData.append(
      'PatientRecordCaseNumber',
      createChatModel.patientRecordCaseNumber
    );
    formData.append('ExpertUserName', createChatModel.expertUserName);
    formData.append(
      'GeneralPractitionerUserName',
      createChatModel.generalPractitionerUserName
    );
    formData.append('Message', createChatModel.message);

    if (createChatModel.file) {
      formData.append('File', createChatModel.file, createChatModel.file.name);
    }

    return this.http.post<any>(url, formData, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
